import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PageWrapper from "../../shared/wizard/PageWrapper";
import Styles from "../AnonForms.module.css";
import { textToBoolean } from "../../../utilities/dataUtilities";
import { yesNo, yesNoUnsure } from "../../../constants/options";
import inputUtilities from "../../../utilities/forms/formInputUtilities";
import { states } from "../../../constants/data";

function Passengers({
  fields,
  utilities,
  passengers,
  otherPassengers,
  setPassengers,
  setOtherPassengers,
}) {
  const passengerObj = useSelector((state) => state.anonAutoForm.passengerObj);

  const { createToggleInput } = utilities;

  const showButton = (array) => array.length < 4;
  const [showPassButton, setShowPassButton] = useState(showButton(passengers));
  const [showOtherPassButton, setShowOtherPassButton] = useState(
    showButton(otherPassengers)
  );

  const addAnother = (e, personArray, personObj, set, prefix = "") => {
    e?.preventDefault(); // don't submit form
      
    const newArray = [...personArray];
    const newPerson = {...personObj};
    for (let fieldName in newPerson) {
      newPerson[fieldName] = {
        ...newPerson[fieldName],
        fieldName: `${prefix}${newPerson[fieldName].fieldName}${personArray.length}`,
      };
    }
    newArray.push(newPerson);
    set(newArray);
  };

  const createPerson = (person, personArray, setPersonArray, desc, index) => {
    const setPerson = (item) => {
      const oldInfo = [...personArray];
      oldInfo[index] = item;
      setPersonArray(oldInfo);
    };
    const createPersonUtilities = inputUtilities(
      person,
      setPerson,
      Styles
    );
    const personNoLabelInput = createPersonUtilities.createNoLabelInput;
    const personNoLabelSelect = createPersonUtilities.createNoLabelSelect;
    const personToggle = createPersonUtilities.createToggleInput;
    return (
      <li key={index} className={`${Styles.fadeIn}`}>
           <div className={Styles.groupedInputs}>
              <div className={Styles.flex1}>
                {personNoLabelInput(person.firstName, "100%", Styles.anonInput)}
               </div>
              <div className={Styles.flex1}>
                {personNoLabelInput(person.lastName, "100%", Styles.anonInput)}
               </div>
            </div>
            <div className={Styles.groupedInputs}>
              <div className={Styles.flex1}>
                {personNoLabelInput(person.address, "100%", Styles.anonInput)}
               </div>
              <div className={Styles.flex1}>
                {personNoLabelInput(person.city, "100%", Styles.anonInput)}
              </div>
            </div>
            <div className={Styles.groupedInputs}>
              <div className={Styles.flex1}>
                {personNoLabelSelect(person.state, "100%", states, Styles.anonSelect, "Select a State")}
              </div>
              <div className={Styles.flex1}>
                {personNoLabelInput(person.zipCode,  "100%", Styles.anonInput)}
              </div>
              <div className={Styles.flex1}>
                {personNoLabelInput(person.phoneNumber, "100%", Styles.anonInput, "tel")}
              </div>
            </div>
            <div className={Styles.groupedInputs}>
              <div className={Styles.flex1}>
                {personToggle(person.isInjured, "100%", yesNo, true)}
              </div>
              <div className={Styles.flex1} style={{justifyContent: "end"}}>
                <button
                    type="button"
                    className={Styles.removeButton}
                    onClick={() => {
                        const info = [...personArray];
                        info.splice(index, 1);
                        setPersonArray(info);
                      }
                      }>
                        Remove {desc} {index + 1}
                </button>
              </div>
            </div>
      </li>
    );
  };

  useEffect(() => {
    setShowPassButton(showButton(passengers));
  }, [passengers.length])//show/hide button - for each button

  useEffect(() => {
    setShowOtherPassButton(showButton(otherPassengers));
  }, [otherPassengers.length])

  useEffect(() => {
    if (textToBoolean(fields.werePassengers.value)) {
      if (passengers?.length < 1) {
        addAnother(null, passengers, passengerObj, setPassengers);
      }
    } else {
      setPassengers([]);
    }
  }, [fields.werePassengers.value])

  useEffect(() => {
    if (textToBoolean(fields.werePassengersOtherVehicle.value)) {
      if (otherPassengers?.length < 1) {
        addAnother(null, otherPassengers, passengerObj, setOtherPassengers, "other");
      } 
    } else {
      setOtherPassengers([]);
    }
  }, [fields.werePassengersOtherVehicle.value])


  return (
    <PageWrapper legendInfo="Passengers: ">
      <div className={Styles.formColumn}>
        <div className={Styles.formRow}>
          {createToggleInput(fields.werePassengers, "100%", yesNoUnsure, true)}
        </div>
        {
          textToBoolean(fields.werePassengers.value) && (
          <>
          <ol>
          {passengers.map((passenger, i) => 
            createPerson(
              passenger,
              passengers,
              setPassengers,
              "Passenger",
              i)
            )}
            </ol>
            {showPassButton && (
              <div className={Styles.addButtonDiv}>
                <button
                  onClick={(e) =>
                    addAnother(e, passengers, passengerObj, setPassengers)
                  }
                  className={Styles.addButton}
                >
                  Add Passenger
                </button>
              </div>
            )}
          </>
        )}
      </div>
      <hr className={Styles.anonHR} />
      {
        fields.otherVehicleInvolved.value && (
        <>
          <div className={Styles.formRow}>
            {createToggleInput(fields.werePassengersOtherVehicle, "100%", yesNoUnsure, true)}
          </div>
          {
            textToBoolean(fields.werePassengersOtherVehicle.value) && (
            <>
                <ol>
                    {otherPassengers.map((passenger, i) => 
                        createPerson(
                            passenger,
                            otherPassengers,
                            setOtherPassengers,
                            "Passenger",
                            i)
                    )}
                </ol>
              {showOtherPassButton && (
                <div className={Styles.addButtonDiv}>
                  <button
                    onClick={(e) =>
                      addAnother(e, otherPassengers, passengerObj, setOtherPassengers, "other")
                    }
                    className={Styles.addButton}
                  >
                    Add Passenger
                  </button>
                </div>
              )}
            </>
          )}
        </>
      )}
    </PageWrapper>
  );
}

export default Passengers;
